import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Observable, Subscription } from 'rxjs';
import { ConfigurationStatus } from '../../../../../domain/consts';
import { ValidationError } from '../../../../../domain/error.model';
import { Offer } from '../../../../../domain/offer.domain';
import { ScheduleFlag } from '../../../../../domain/schedule.model';
import { EntityRole, SystemUser } from '../../../../../domain/user.model';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { DialogAction } from '../../../store/dialog.action';
import { ErrorsState } from '../../../store/errors.state';
import { OfferAction } from '../../../store/offer.action';
import { OfferState } from '../../../store/offer.state';
import { ScheduleState } from '../../../store/schedule.state';
import { UserState } from '../../../store/user.state';

@Component({
    selector: 'app-calculation-summary',
    templateUrl: './calculation-summary.component.html',
    styleUrls: ['./calculation-summary.component.scss']
})
export class CalculationSummaryComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    offer: Offer;
    initial: Offer;
    subscriptions: Subscription[] = [];
    locationEditMode: boolean;
    location: string;
    flag: ScheduleFlag;
    user: SystemUser;

    @Select(ErrorsState.getMainErrors) errors$: Observable<ValidationError[]>;
    errors: ValidationError[] = [];
    matchers = {
        location: new LsnErrorStateMatcher(this, 'additionalData.location'),
        generic: new LsnErrorStateMatcher(this, null),

    };

    get readonly() {
        return this.flag.active === false
            || [EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES].indexOf(this.user.entityRole) === -1;
    }

    get isActiveSales() {
        return this.flag.active === true
            && [EntityRole.WORKER, EntityRole.AGENT].indexOf(this.user.entityRole) !== -1;
    }

    get hasFinishedProducts() {
        return this.offer.premium !== null &&
            this.initial.productList
                .filter(p => p.configuration.configurationStatus === ConfigurationStatus.COMPLETED)
                .length > 0;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.initial = cloneDeep(this.store.selectSnapshot(OfferState.getOffer));
        this.subscriptions.push(
            this.store.select(ErrorsState.getMainErrors).subscribe(errors => this.errors = errors),
            this.store.select(OfferState.getOffer).subscribe(offer => {
                this.offer = cloneDeep(offer);
                this.location = this.offer.additionalData.location;
                this.locationEditMode = !this.offer.additionalData.location;
            }),
            this.store.select(ScheduleState.getFlag).subscribe(flag => this.flag = flag),
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    createOffer() {
        this.store.dispatch(new OfferAction.CreateOffer(this.initial));
    }

    createPolicy() {
        this.store.dispatch(new OfferAction.IssueFromCalculation(this.initial));
    }

    editLocation() {
        this.store.dispatch(new DialogAction.OpenLocationDialog(this.offer.id, this.offer.additionalData.location));
    }
}
